import React from "react";
import { Clock, Wrench } from "lucide-react";

interface Props {
  normLabel?: string;
}

const WorkInProgress: React.FC<Props> = ({ normLabel }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    gap: 20,
    color: "#6b7280",
    textAlign: "center",
    padding: 40,
  }}>
    <div style={{
      width: 80,
      height: 80,
      borderRadius: "50%",
      background: "#f3f4f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <Wrench size={36} color="#9ca3af" />
    </div>
    <h2 style={{ fontSize: 24, fontWeight: 700, color: "#374151", margin: 0 }}>
      En cours de développement
    </h2>
    {normLabel && (
      <p style={{ fontSize: 16, color: "#6b7280", margin: 0 }}>
        Le module <strong>{normLabel}</strong> est actuellement en cours d'implémentation.
      </p>
    )}
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      background: "#fef3c7",
      color: "#92400e",
      padding: "10px 20px",
      borderRadius: 8,
      fontSize: 14,
    }}>
      <Clock size={16} />
      <span>Disponible prochainement</span>
    </div>
  </div>
);

export default WorkInProgress;
